import script from "./MallHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallHeader.vue?vue&type=script&setup=true&lang=ts"

import "./MallHeader.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__